<ng-scrollbar
  style="height: calc(100vh - 88px)"
  visibility="hover"
  orientation="vertical"
  [dir]="direction">
  @if (showContent) {
    <app-card
      [showHeader]="false"
      cardClass="user-card"
      padding="20">
      <div class="flex align-item-center">
        <div class="flex-shrink-0">
          <img
            src="assets/images/user/avatar-1.jpg"
            alt="user-image"
            class="user-avatar" />
        </div>
        <div class="flex-grow-1 user-details">
          <div class="f-w-600">{{ this.authenticationService.currentUserName }}</div>
          <div class="mat-caption"></div>
        </div>
        <div class="user-setting">
          <a
            href="javascript:"
            [matMenuTriggerFor]="menu"
            class="text-muted">
            <svg class="pc-icon">
              <use xlink:href="assets/fonts/custom-icon.svg#custom-sort-outline"></use>
            </svg>
          </a>
          <mat-menu
            #menu="matMenu"
            [overlapTrigger]="false"
            yPosition="below"
            xPosition="after">
            <button mat-menu-item>
              <a
                [routerLink]="['/profile']"
                class="text-muted">
                <i class="ti ti-user f-18 m-r-10"></i>
                <span>My Account</span>
              </a>
            </button>
            <button
              mat-menu-item
              *aclFeatures="ADMIN_ADVANCED">
              <a
                href="javascript:"
                class="text-muted"
                [routerLink]="['/conf']">
                <i class="ti ti-settings f-18 m-r-10"></i>
                <span>Settings</span>
              </a>
            </button>

            <button mat-menu-item>
              <a
                class="text-muted"
                (click)="logout()">
                <i class="ti ti-power f-18 m-r-10"></i>
                <span>Logout</span>
              </a>
            </button>
          </mat-menu>
        </div>
      </div>
    </app-card>
  }
  <div class="navbar-content">
    <ul
      class="nav coded-inner-navbar"
      (click)="fireOutClick()">
      @for (item of menus(); track item) {
        @if (item.type === "group") {
          <app-menu-group-vertical [item]="item" />
        } @else if (item.type === "item") {
          <app-menu-item [item]="item" />
        } @else if (item.type === "collapse") {
          <app-menu-collapse [item]="item" />
        }
      }
    </ul>
  </div>
</ng-scrollbar>
